export const forums = {
  forumsSearchInputPlaceholder: 'Cerca',
  forumsFollowDiscussionButtonTitle: 'Segui',
  forumsFollowingDiscussButtonTitle: 'Seguito',
  forumDiscussionInfoNoReplyText: 'Nessuna risposta ancora',
  forumsDiscussionDetailsStartButtonTitle: 'Avvia discussione',
  forumDetailsCreatedByText: 'di',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Copia link',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Segnala contenuto',
  forumsReportedCurtainContent: 'Contenuto segnalato',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Link copiato!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Fissa discussione',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Scollega discussione',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Modifica discussione',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Elimina discussione',
  forumsDiscussionDetailspPopupDeleteTitle: 'Elimina',
  forumsDiscussionDetailspPopupDeleteText: 'Eliminare questa discussione?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Annulla',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Conferma',
  forumsDiscussionDetailsDeleledAlertText: 'Discussione eliminata!',
  forumsNewDiscussionTitle: 'Nuova discussione',
  forumsNewDiscussionTitlePlaceholder: 'Titolo...',
  forumsNewDiscussionBodyPlaceholderText: 'Inserisci qui il tuo testo...',
  forumsNewDiscussionPublishButtonTitle: 'Pubblica',
  forumsNewDiscussionLocationCurtainTitle: 'Posizione',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Nome posizione',
  forumsNewDiscussionEditLocationCurtainText: 'Modifica posizione',
  forumsNewDiscussionDeleteLocationCurtainText: 'Elimina posizione',
  forumsNewDiscussionCreatePollTitle: 'Crea sondaggio',
  forumsNewDiscussionTitleInputPlaceholder: 'Titolo',
  forumsNewDiscussionOptionInputPlaceholder: 'Opzione',
  forumsNewDiscussionAddButtonTitle: 'Aggiungi opzione',
  forumsNewDiscussionCreateButtonTitle: 'Crea',
  forumsNewDiscussionPollTitleBlankAlertText: 'Il titolo non può essere vuoto!',
  forumsNewDiscussionPollOptionBlankAlertText: "L'opzione non può essere vuota!",
  forumsNewDiscussionPollLongTitleAlertText: 'Il titolo deve contenere al massimo 140 caratteri',
  forumsNewDiscussionPollLongOptionAlertText: "L'opzione deve contenere al massimo 50 caratteri",
  forumsNewDiscussionEditPollIconText: 'Modifica sondaggio',
  forumsNewDiscussionRemovePollIconText: 'Rimuovi sondaggio',
  forumsDiscardDraftPopupTitle: 'Bozza',
  forumsDiscardDraftPopupText: 'Eliminare questa bozza?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Annulla',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Conferma',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Rispondi',
  forumsDiscussionDetailsNoCommentsText: 'Non ci sono ancora commenti\nPuoi essere il primo',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Rispondi',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Copia link',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Link copiato!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Segnala contenuto',
  forumsDiscussionDetailsPostCurtainReportedText: 'Contenuto segnalato',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Rispondi',
  forumsEditDiscussionTitle: 'Modifica discussione',
  forumsEditDiscussionSaveButtonTitle: 'Salva',
  forumsEditedDiscussionSavedAlertText: 'Discussione salvata!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Modifica risposta',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Elimina risposta',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Commento salvato!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Commento eliminato!',
  forumsAlertSomethinWrong: 'Qualcosa è andato storto!',
  forumsMaxMbSize: 'Puoi caricare al massimo {size} MB alla volta',
  forumsMaxAttachments: 'Hai superato il numero massimo di allegati. Il massimo numero di allegati è {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Elimina',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Eliminare questo commento?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Annulla',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Conferma',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Segnala contenuto',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Contenuto segnalato',
  forumDiscussionInfoLastReplyText: 'Ultima risposta',
  forumsDiscussionAt: 'alle',
  forumsDiscussionDetailsFlagCurtainTitle: 'Segnala contenuto',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Contenuto segnalato',
  forumsPollInfoVotesText: 'voti',
  forumsPollInfoEditVoteText: 'Modifica voto',
  forumsPollFinishPollText: 'Concludi il sondaggio',
  forumsPollFinishedPollText: 'Concluso',
  forumsPollInProgresslText: 'In corso',
  forumsPollCurtainTitle: 'Concludi il sondaggio',
  forumsPollCurtainText: 'Gli utenti non potranno votare dopo che il sondaggio sarà concluso.',
  forumsFinishPollCurtainCancelButtonTitle: 'Annulla',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Conferma',
  forumsPollInfoPollVotesCurtainTitle: 'Voti del sondaggio'
}
